import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { Dashboard as D } from '../../features/dashboard'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function Dashboard(props: RouteProps) {
  const { setTitle } = useTitleHeaderContext()
  setTitle(props.title || '')

  return <D id={props.id} />
}
